import React, { useState, useEffect } from "react";
import { Spinner } from "reactstrap";

const RenderResourcesVideos = ({ resourcesVideos }) => {
  const [loading, setLoading] = useState(
    new Array(resourcesVideos.length).fill(true)
  );

  useEffect(() => {
    setLoading(new Array(resourcesVideos.length).fill(true));
  }, [resourcesVideos]);

  const handleLoad = (index) => {
    setLoading((prevState) => {
      const newLoadingState = [...prevState];
      newLoadingState[index] = false;
      return newLoadingState;
    });
  };

  return (
    <div className="row mt-3">
      {resourcesVideos.map((video, index) => (
        <div key={index} className="col-md-6 mb-4">
          <div className="rounded-4 p-3 text-center">
            <div className="d-flex align-items-center mb-3 text-start">
              <h3>{video.name}</h3>
            </div>
            {loading[index] && (
              <div
                className="d-flex align-items-center pt-5  justify-content-center"
                style={{ height: "30px" }}
              >
                <Spinner
                  color="primary"
                  style={{ width: "3rem", height: "3rem" }}
                />
              </div>
            )}

            <div
              style={{
                position: "relative",
                paddingBottom: "62.5%",
                height: 0,
              }}
            >
              <iframe
                src={video.link}
                frameborder="0"
                webkitallowfullscreen
                mozallowfullscreen
                allowfullscreen
                onLoad={() => handleLoad(index)}
                style={{
                  display: loading[index] ? "none" : "block",
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                }}
              ></iframe>
            </div>
            {/* <iframe
              src={video.link}
              frameBorder="0"
              webkitallowfullscreen="true"
              mozallowfullscreen="true"
              allowFullScreen
              onLoad={() => handleLoad(index)}
              style={{
                width: "100%",
                height: "300px",
                borderRadius: "10px",
                display: loading[index] ? "none" : "block",
              }}
            ></iframe> */}
          </div>
        </div>
      ))}
    </div>
  );
};

export default RenderResourcesVideos;
